// src/utils/timezone.ts
// Timezone Utility - Generates US timezone options with current time display
// Provides comprehensive timezone list for organization settings and forms
// RELEVANT FILES: src/components/app-sidebar/nav-team-add.vue, src/components/app-sidebar/nav-team-manage.vue

export interface TimezoneOption {
  value: string;
  label: string;
}

/**
 * Generates a list of US timezone options with current local time
 * @returns Array of timezone options with formatted labels showing current time
 */
export function generateTimezoneOptions(): TimezoneOption[] {
  const now = new Date();
  const baseTimezones = [
    // Eastern Time Zone
    { value: 'America/New_York', label: 'Eastern Time (ET)', cities: 'New York, Miami, Boston' },

    // Central Time Zone
    { value: 'America/Chicago', label: 'Central Time (CT)', cities: 'Chicago, Houston, Dallas' },

    // Mountain Time Zone
    { value: 'America/Denver', label: 'Mountain Time (MT)', cities: 'Denver, Salt Lake City' },

    // Arizona - No DST
    { value: 'America/Phoenix', label: 'Arizona Time (MST)', cities: 'Phoenix, Tucson' },

    // Pacific Time Zone
    {
      value: 'America/Los_Angeles',
      label: 'Pacific Time (PT)',
      cities: 'Los Angeles, Seattle, San Francisco',
    },

    // Alaska Time Zone
    { value: 'America/Anchorage', label: 'Alaska Time (AKT)', cities: 'Anchorage, Fairbanks' },

    // Hawaii Time Zone
    { value: 'Pacific/Honolulu', label: 'Hawaii Time (HST)', cities: 'Honolulu, Maui, Kauai' },

    // UTC (for reference)
    { value: 'UTC', label: 'UTC', cities: 'Coordinated Universal Time' },
  ];

  return baseTimezones.map(tz => {
    const currentTime = now.toLocaleTimeString('en-US', {
      timeZone: tz.value,
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });

    return {
      value: tz.value,
      label: `${tz.label} - ${currentTime} (${tz.cities})`,
    };
  });
}
